/* 🤖 this file was generated by svg-to-ts */
export const kzIconsSocialMessages: {
  name: 'social_messages';
  data: string;
} = {
  name: 'social_messages',
  data: `<svg fill="none" viewBox="0 0 24 24"><path d="M4.8 5h14.4c.99 0 1.8.787 1.8 1.75v10.5c0 .962-.81 1.75-1.8 1.75H4.8c-.99 0-1.8-.788-1.8-1.75V6.75C3 5.787 3.81 5 4.8 5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="m21 7-9 6-9-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
